export default __webpack_public_path__ + "static/media/logo-que.f8fb9378.png";